import type { SVGProps } from 'react';

interface BitcoinIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const BitcoinIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & BitcoinIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 20 20"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <circle cx={10} cy={10} fill="#4FA9FF" r={10} />
    <path
      clipRule="evenodd"
      d="M15.505 8.382c.227-1.687-1.053-2.568-2.808-3.164l.545-2.282-1.388-.335-.528 2.233a35 35 0 0 0-1.107-.248l.529-2.233-1.404-.335L8.799 4.3a16 16 0 0 0-.448-.097q-.226-.045-.448-.097l-1.912-.46-.351 1.477s1.036.228 1 .248c.56.141.668.51.647.79l-.615 2.601q.02.009.044.014a.3.3 0 0 1 .097.04q-.04-.011-.07-.016a1 1 0 0 1-.07-.017l-.843 3.64c-.07.173-.248.421-.632.334.017.017-1.02-.248-1.02-.248l-.657 1.6 1.81.422q.196.05.391.097c.202.049.4.096.59.152l-.544 2.303 1.387.335.545-2.283c.389.104.756.194 1.107.281l-.545 2.267 1.387.335.546-2.304c2.37.422 4.141.228 4.86-1.935.578-1.725-.054-2.709-1.317-3.358.925-.211 1.593-.81 1.767-2.039m-2.738 0c-.341 1.453-2.46.905-3.39.665l-.19-.049.67-2.775q.125.03.302.068c.978.21 2.955.633 2.608 2.091m-.384 4.479c-.374 1.594-2.89.948-4.005.661l-.244-.062.719-3.06c.1.025.225.051.365.082 1.183.255 3.542.764 3.165 2.379"
      fill="#fff"
      fillRule="evenodd"
    />
  </svg>
);
